import {
  getFirestore,
  collection,
  CollectionReference,
  getDoc,
  doc,
  Query,
  query,
  where,
  getDocs,
} from 'firebase/firestore';

import { toast } from '@/components/Toaster/Toast';

import type { ITag, TagInDatabase } from './getFirebaseTag';

import { safePromise } from './safePromise';

export async function getFirebaseTagsForOrganization(
  organizationId: string,
  userId?: string,
): Promise<ITag[] | undefined> {
  const firestore = getFirestore();

  // Reference to the 'tags' subcollection
  const tagsRef = collection(firestore, 'organizations', organizationId, 'tags') as CollectionReference<TagInDatabase>;

  // Build a query: either all tags, or only this user's tags
  const tagsQuery: Query<TagInDatabase> = userId ? query(tagsRef, where('user', '==', userId)) : query(tagsRef);

  // Get the config from the database
  const [data, error] = await safePromise(getDocs(tagsQuery));

  if (error) {
    toast({
      variant: 'error',
      title: 'Unable to retrieve tags',
      description: 'Please try again later',
    });

    return undefined;
  }

  // Check if the config exists
  if (!data || !data.size) {
    return undefined;
  }

  const resolvedTags = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));

  return resolvedTags;
}
